import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Badge } from './ui';
export interface PricingPlan {
  id: string;
  title: string;
  price: string;
  period: string;
  badge?: string;
  badgeColor?: 'lime' | 'orange' | 'crimson' | 'gold' | 'slate';
  borderClass: string;
  glowClass: string;
  description: string;
  features?: string[];
  ctaText: string;
  ctaClass: string;
  popular?: boolean;
  subNote?: string;
  fundraisingNote?: boolean;
}
export const PricingCard = ({
  plan
}: {
  plan: PricingPlan;
}) => {
  return <motion.div whileHover={{
    y: -10
  }} className={`relative bg-dark rounded-2xl p-8 border-2 flex flex-col h-full transition-all duration-300 ${plan.borderClass} ${plan.glowClass}`} data-id="element-408">
      {plan.badge && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-409">
          <Badge color={plan.badgeColor} data-id="element-410">{plan.badge}</Badge>
        </div>}

      <div className="text-center mb-6 mt-2" data-id="element-411">
        <h3 className="font-heading font-black text-3xl uppercase tracking-wide mb-2" data-id="element-412">
          {plan.title}
        </h3>
        <div className="flex items-baseline justify-center gap-1" data-id="element-413">
          <span className="text-5xl font-black font-mono tracking-tighter" data-id="element-414">
            {plan.price}
          </span>
          {plan.period && <span className="text-slate font-medium" data-id="element-415">/{plan.period}</span>}
        </div>
      </div>

      <p className="text-center text-lg font-medium mb-8 text-white/90" data-id="element-416">
        {plan.description}
      </p>

      {plan.features && plan.features.length > 0 && <ul className="space-y-4 mb-8 flex-1" data-id="element-417">
          {plan.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-418">
              <div className="mt-1 bg-white/10 p-1 rounded-full text-lime shrink-0" data-id="element-419">
                <Check size={14} strokeWidth={3} data-id="element-420" />
              </div>
              <span className="text-slate leading-tight" data-id="element-421">{feature}</span>
            </li>)}
        </ul>}

      <div className="mt-auto pt-6" data-id="element-422">
        <button className={`w-full py-4 rounded-xl font-black font-heading text-xl uppercase tracking-wide transition-all ${plan.ctaClass}`} data-id="element-423">
          {plan.ctaText}
        </button>
        {plan.subNote && <p className="text-xs text-slate text-center mt-4 leading-relaxed" data-id="element-424">
            {plan.subNote}
          </p>}
        {plan.fundraisingNote && <p className="text-xs text-lime/80 text-center mt-4 font-medium italic" data-id="element-425">
            Margins support school fundraising programs
          </p>}
      </div>
    </motion.div>;
};